import React from 'react';
import PropTypes from 'prop-types';
import ComponentBadgeImage from 'components/component-badge-view';
import EmailEditorContainer from '../containers/email-editor-container';
import PasswordEditorContainer from '../containers/password-editor-container';
import EnhancedSecurityContainer from '../containers/enhanced-security-container';
import SocialAccountsContainer from '../containers/social-accounts-container';
import EnterpriseSignInContainer from '../containers/enterprise-signin-container';
import EmailSubscriptionOptOutContainer from '../containers/email-subscription-opt-out-container';
import DevicesEditorContainer from '../containers/devices-editor-container';
import classes from './signin-security.scss';
import {
  injectIntl,
  defineMessages,
} from 'react-intl';

const t = defineMessages({
  'signin-security.icon-security': {
    id: 'signin-security.icon-security',
    defaultMessage: 'Sign In & Security logo',
    description: 'Hover text to display for the Sign In and Security Lock image',
  },
});

const SignInSecurity = ({
  intl,
  isOrganizationMember,
  socialLoginEnabled,
  socialAccounts,
  socialSignInLinks,
  enterpriseSignInEnabled,
  forceSamlSsoLogin,
  openDevicesDialogOnLoad,
}) => (
  <div>
    <ComponentBadgeImage
      iconFontName="togo-icon-lock-closed"
      title={intl.formatMessage(t['signin-security.icon-security'])}
    />
    <div id="sign-in-security-section" className={classes['signinSecurityContainer']}>
      <form>
        <div className="row">
          <div className={`col-xs-12 col-sm-6 ${classes['siColumn']}`}>
            <EmailEditorContainer
              isOrganizationMember={isOrganizationMember}
            />
            {!forceSamlSsoLogin &&
              <PasswordEditorContainer
                isOrganizationMember={isOrganizationMember}
                socialLoginEnabled={socialLoginEnabled}
                socialAccounts={socialAccounts}
                socialSignInLinks={socialSignInLinks}
              />}
            <EmailSubscriptionOptOutContainer />
            {enterpriseSignInEnabled &&
              <EnterpriseSignInContainer />}
          </div>
          <div className={`col-xs-12 col-sm-6 ${classes['siColumn']}`}>
            <DevicesEditorContainer
              openDevicesDialogOnLoad={openDevicesDialogOnLoad}
            />
          </div>
          <div className={`col-xs-12 col-sm-6 ${classes['siColumn']}`}>
            <EnhancedSecurityContainer />
          </div>
          {socialLoginEnabled &&
            <div className={`col-xs-12 col-sm-6 ${classes['siColumn']}`}>
              <SocialAccountsContainer
                socialAccounts={socialAccounts}
                socialSignInLinks={socialSignInLinks}
              />
            </div>}
        </div>
      </form>
    </div>
  </div>
);

SignInSecurity.propTypes = {
  intl: PropTypes.object.isRequired,
  isOrganizationMember: PropTypes.bool.isRequired,
  enterpriseSignInEnabled: PropTypes.bool.isRequired,
  socialLoginEnabled: PropTypes.bool.isRequired,
  socialAccounts: PropTypes.array.isRequired,
  socialSignInLinks: PropTypes.object.isRequired,
  forceSamlSsoLogin: PropTypes.bool.isRequired,
  openDevicesDialogOnLoad: PropTypes.bool.isRequired,
};

export default injectIntl(SignInSecurity);
